












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PlaceHolderInline extends Vue {
	@Prop({ default: true })
	private placehold!: boolean;

	@Prop({ default: 'light' })
	private theme!: string;

	@Prop({ default: '3em' })
	private width!: string;
}
